import { readRoleById } from 'api/role';

export const getRoleById = (id: string) => readRoleById({ id }).then(({ data }) => data);
